import { render, staticRenderFns } from "./DIVView.vue?vue&type=template&id=4565cb9b&style=display%3Ainline%3Boverflow%3Ahidden"
import script from "./DIVView.vue?vue&type=script&lang=js"
export * from "./DIVView.vue?vue&type=script&lang=js"
import style0 from "./DIVView.vue?vue&type=style&index=0&id=4565cb9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports